import { useEffect, useRef, useState } from 'react';

function useDebounceNameAndDescription(
  name: string,
  description?: string,
  debounceTime = 5000,
) {
  const [debouncedName, setDebouncedName] = useState(name);
  const [debouncedDescription, setDebouncedDescription] = useState(description);
  const timerRef = useRef<number>(0);

  useEffect(() => {
    if (timerRef.current) {
      window.clearTimeout(timerRef.current);
    }

    timerRef.current = window.setTimeout(() => {
      setDebouncedName(name);
      setDebouncedDescription(description);
    }, debounceTime);

    return () => {
      if (timerRef.current) {
        window.clearTimeout(timerRef.current);
      }
    };
  }, [name, description, debounceTime]);

  return { debouncedName, debouncedDescription };
}

export default useDebounceNameAndDescription;
